export default __webpack_public_path__ + "static/media/cliorin.3007d354.jpg";